import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
function SimpleModal({ show, onClose = null, header = "Alert", body = "", primaryBtn = null, secondaryBtn = null}) {
return (
    <>
        <Modal aria-labelledby="contained-modal-title-vcenter" centered="true" show={show} onHide={onClose} animation={true}>
            <Modal.Header closeButton>
                <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                {secondaryBtn &&
                <Button variant="secondary" onClick={onClose}>
                    {secondaryBtn}
                </Button>
                }
                {primaryBtn &&
                    <Button variant="primary" onClick={onClose}>
                        {primaryBtn}
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    </>
)
}
export default SimpleModal
